module.exports = __webpack_public_path__ + "img/myguard_pro_03.8855f9a0.png";